// @flow
export const whatsappURL = (phone: string, text: string): string => {
  return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(text)}`;
};
